// extracted by mini-css-extract-plugin
export default {"tipOfTheDay":"TipOfTheDay_tipOfTheDay__ZFAym","tipTitle":"TipOfTheDay_tipTitle__3zK26","tipContent":"TipOfTheDay_tipContent__wpyON"};